import React from 'react';
import { TextField, TextFieldProps } from '@mui/material';
import { styled } from '@mui/material/styles';

// Extended input props interface
interface InputProps extends Omit<TextFieldProps, 'variant'> {
  variant?: 'outlined' | 'filled' | 'standard';
}

// Styled input with custom styling
const StyledTextField = styled(TextField)(({ theme }) => ({
  '& .MuiOutlinedInput-root': {
    borderRadius: theme.spacing(1),
    '& fieldset': {
      borderColor: theme.palette.grey[300],
    },
    '&:hover fieldset': {
      borderColor: theme.palette.primary.main,
    },
    '&.Mui-focused fieldset': {
      borderColor: theme.palette.primary.main,
      borderWidth: 2,
    },
  },
  '& .MuiInputLabel-root': {
    color: theme.palette.text.secondary,
    '&.Mui-focused': {
      color: theme.palette.primary.main,
    },
  },
}));

/**
 * Custom Input atom component
 * Extends Material-UI TextField with custom styling
 */
export const Input: React.FC<InputProps> = ({
  variant = 'outlined',
  fullWidth = true,
  ...props
}) => {
  return (
    <StyledTextField
      variant={variant}
      fullWidth={fullWidth}
      {...props}
    />
  );
}; 